import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from '@app/shared-module/common-service.service';
import { Constants } from '@app/shared-module/constants';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor(private httpClient: HttpClient, private commonService: CommonService) {}

  getDoctorSubscriptions(itemsPerPage: number = 10, pageNumber: number = 0) {
    const params = new HttpParams()
      .set(Constants.ITEMS_PER_PAGE, itemsPerPage.toString())
      .set(Constants.PAGE_NUMBER, pageNumber.toString());
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_SUBSCRIPTIONS_API,
      { params }
    );
  }

  fetchDoctorSubscriptionsDetails(doctorID: string) {
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_SUBSCRIPTION_API +
        doctorID
    );
  }

  updateDoctorSubscription(item: any, doctorID: string) {
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_SUBSCRIPTION_API +
        doctorID,
      item
    );
  }

  updateMaxDoctor(maxDoctors: any, doctorID: string) {
    const postData = {
      maxDoctors
    };
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_SUBSCRIPTION_API +
        doctorID +
        Constants.MAX_ACTIVE_DOCTOR_API,
      postData
    );
  }

  deactivateSubscription(item: any, doctorID: string) {
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_SUBSCRIPTION_API +
        doctorID +
        Constants.INACTIVE_API,
      item
    );
  }

  activateSubscription(item: any, doctorID: string) {
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_SUBSCRIPTION_API +
        doctorID +
        Constants.ACTIVE_API,
      item
    );
  }

  // https://dev.pawsnme.com/api/v1/doctor/5ece9e631f548034351fab37/addDoctor/request
  requestDoctorLimitIncrease() {}

  getInternalUserList(itemsPerPage: number = 10, pageNumber: number = 0) {
    const params = new HttpParams()
      .set(Constants.ITEMS_PER_PAGE, itemsPerPage.toString())
      .set(Constants.PAGE_NUMBER, pageNumber.toString());
    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.ITERNAL_USERS_API, { params });
  }

  fetchInternalUserDetails(userID: string) {
    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API + userID);
  }

  updateInternalUserDetails(userID: string, name: any) {
    return this.httpClient.put(Constants.MAIN_ENV_URL + Constants.INTERNAL_USER_API + userID, { name });
  }

  addInternalUser(item: any) {
    return this.httpClient.post(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.USER_API,
      item
    );
  }

  changePassword(userID: string, oldPassword: string, newPassword: string) {
    const user = {
      internalUserId: userID,
      oldPassword,
      newPassword
    };
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.CHANGE_PASSWORD_API, user);
  }

  hardResetPassword(email: string, password: string) {
    const user = {
      email,
      password
    };
    return this.httpClient.post(Constants.HARD_RESET_DOCTOR_PASSWORD, user);
  }

  updateInternalUserStatus(userID: string, status: string) {
    const user = {
      internalUserId: userID,
      status
    };
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.USER_API,
      user
    );
  }

  uploadInternalUserRole(userID: string, role: string) {
    const user = {
      internalUserId: userID,
      role
    };
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.USER_API +
        Constants.ROLE_API,
      user
    );
  }

  uploadInternalUserProfileImage(item: any) {
    return this.httpClient.post(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        Constants.UPLOAD_PROFILE_IMAGE_API +
        this.commonService.internalLoginValue._id,
      item
    );
  }

  // https://dev.pawsnme.com/api/v1/doctor/doctorLead
  addDoctorLead() {}

  updateDoctorLead(item: any, doctorID: string) {
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_LEAD_API +
        doctorID,
      item
    );
  }

  fetchDoctorLeadDetails(doctorID: string) {
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_LEAD_API +
        doctorID
    );
  }

  getDoctorLeads(itemsPerPage: number = 10, pageNumber: number = 0) {
    const params = new HttpParams()
      .set(Constants.ITEMS_PER_PAGE, itemsPerPage.toString())
      .set(Constants.PAGE_NUMBER, pageNumber.toString());
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_LEADS_API,
      { params }
    );
  }

  rejectDoctorLead(doctorID: string, item: any) {
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_LEAD_API +
        doctorID +
        Constants.REJECTED_API,
      item
    );
  }

  fetchDoctorPlans() {
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTORPLANS_API
    );
  }

  approveDoctorLead(doctorID: string, item: any) {
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_LEAD_API +
        doctorID +
        Constants.APPROVED_API,
      item
    );
  }

  getRepaymentDetails(
    fromDate: any,
    toDate: any,
    itemsPerPage: number = 10,
    pageNumber: number = 0,
    clinics: string = ''
  ) {
    const params = new HttpParams()
      .set(Constants.FROM_DATE, fromDate.year + '-' + fromDate.month + '-' + fromDate.day)
      .set(Constants.TO_DATE, toDate.year + '-' + toDate.month + '-' + toDate.day)
      .set(Constants.ITEMS_PER_PAGE, itemsPerPage.toString())
      .set(Constants.PAGE_NUMBER, pageNumber.toString())
      .set('clinics', clinics);
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.CLINIC_PAYMENTS_API,
      { params }
    );
  }

  updateClinicPayment(clinicID: string, item: any) {
    return this.httpClient.put(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.CLINIC_PAYMENT_API +
        clinicID,
      item
    );
  }

  getTransactionList(
    fromDate: any,
    toDate: any,
    clinics: string,
    doctors: string,
    searchString: string,
    searchBoxCus: string,
    itemsPerPage: number,
    pageNumber: number
  ) {
    const params = new HttpParams()
      .set(Constants.FROM_DATE, fromDate.year + '-' + fromDate.month + '-' + fromDate.day)
      .set(Constants.TO_DATE, toDate.year + '-' + toDate.month + '-' + toDate.day)
      .set('clinics', clinics)
      .set('doctors', doctors)
      .set('search', searchString)
      .set('mobile_number', searchBoxCus)
      .set(Constants.ITEMS_PER_PAGE, itemsPerPage.toString())
      .set(Constants.PAGE_NUMBER, pageNumber.toString());
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.CUSTOMER_PAYMENTS_API,
      { params }
    );
  }

  getTransactionDashboard(
    fromDate: any,
    toDate: any,
    clinics: string,
    doctors: string,
    frequency: string,
    metric: string
  ) {
    const params = new HttpParams()
      .set(Constants.FROM_DATE, fromDate.year + '-' + fromDate.month + '-' + fromDate.day)
      .set(Constants.TO_DATE, toDate.year + '-' + toDate.month + '-' + toDate.day)
      .set('clinics', clinics)
      .set('frequency', frequency)
      .set('metric', metric)
      .set('doctors', doctors);
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.DOCTOR_DASHBOARD_API,
      { params }
    );
  }

  getClinicList() {
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.CLINICS_API
    );
  }

  getDoctorList(clinicID: string) {
    return this.httpClient.get(
      Constants.MAIN_ENV_URL +
        Constants.INTERNAL_USER_API +
        this.commonService.internalLoginValue._id +
        Constants.CLINIC_API +
        clinicID +
        Constants.DOCTORS_API
    );
  }
}
